module.exports = __webpack_public_path__ + "static/img/92052A_1_C_2020301_LC.542d95f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/92052A_1_C_2020301_LC.png
// module id = lP8o
// module chunks = 0